const isBaseballEvent = (sportId) => sportId === "7";
// eslint-disable-next-line complexity
export function getTeamsScore(eventScore, sportId) {
    const mainScore = eventScore.mainScore;
    const gamePartScores = eventScore.gamePartScores || [];
    const extraPartScores = eventScore.extraPartScores || [];
    const currentGamePartScore = eventScore.currentGamePartScore;
    const preparedScore = [{
            name: (mainScore === null || mainScore === void 0 ? void 0 : mainScore.name) || (currentGamePartScore === null || currentGamePartScore === void 0 ? void 0 : currentGamePartScore.name) || "",
            homeScore: (mainScore === null || mainScore === void 0 ? void 0 : mainScore.homeScore) || (currentGamePartScore === null || currentGamePartScore === void 0 ? void 0 : currentGamePartScore.homeScore) || "",
            awayScore: (mainScore === null || mainScore === void 0 ? void 0 : mainScore.awayScore) || (currentGamePartScore === null || currentGamePartScore === void 0 ? void 0 : currentGamePartScore.awayScore) || "",
        }];
    const statScores = isBaseballEvent(sportId) ? (eventScore.statScores || []) : [];
    const scores = [...gamePartScores, ...extraPartScores, ...preparedScore, ...statScores];
    return scores.reduce((acc, score, index) => {
        acc.scoreParts[index] = score.name || "";
        acc.homeScore[index] = score.homeScore || "-";
        acc.awayScore[index] = score.awayScore || "-";
        return acc;
    }, { scoreParts: [], homeScore: [], awayScore: [] });
}
//# sourceMappingURL=getTeamsScore.js.map